export default async ({ store, next }) => {
  let authToken = store.getters['auth/authToken']
  let params = new URL(document.location).searchParams
  let token = params.get('token')
  if (token) {
    try {
      await store.dispatch('auth/loginWithToken', token)
      const selectedBusinessId = store.getters['user/selectedBusinessId']
      if (selectedBusinessId) {
        return next({ name: 'Location' })
      } else {
        return next({ name: 'Business' })
      }
    } catch (error) {
      localStorage.clear()
    }
  }
  if (authToken) {
    return next({ name: 'Business' })
  } else {
    return next()
  }
}
